
import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import { getLoginHintKeyFromPath } from "../utils/paymentUiMessages";
import { Loading } from "./ui";

const ProtectedRoute = ({ children }) => {
  const { user, isLoading } = useContext(AuthContext);
  const location = useLocation();

  if (isLoading) {
    return <Loading fullScreen message="Carregando sua sessão..." />;
  }

  if (!user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: location,
          loginHintKey: getLoginHintKeyFromPath(location.pathname),
        }}
      />
    );
  }

  return children;
};

export default ProtectedRoute;

